import { MSHttpEvent } from 'src/app/adapters/http/utils/http.utils';
import { BingMapsLocationHttpResponse } from '../../utils/bing-maps.utils';
import { MSLatLng, MSLatLngPlace } from 'src/app/models/map.model';
import { TypeTransformerUseCase } from 'src/app/use-case/type-transformer/type-transformer.use-case';

export namespace ReverseGeocodeEvent {
  export class Success {
    constructor(readonly place: MSLatLngPlace) {}
  }
  export class Error {}
  export class Loading {}

  export type Spec = Success | Error | Loading;
}

export function mapLocationHttpResponseToReverseGeocodeEvent(
  transformer: TypeTransformerUseCase,
  originalPoint: MSLatLng,
  response: MSHttpEvent.Spec
): ReverseGeocodeEvent.Spec {
  if (response instanceof MSHttpEvent.Success) {
    const data = transformer.transformToType(BingMapsLocationHttpResponse, response.data);
    const resource = data.resourceSets[0].resources[0];
    const successEvent = new ReverseGeocodeEvent.Success({
      lat: originalPoint.lat,
      lng: originalPoint.lng,
      name: resource.address.formattedAddress
    });
    return successEvent;
  } else if (response instanceof MSHttpEvent.Error) {
    const errorEvent = mapLocationHttpErrorToReverseGeocodeErrorEvent(response);
    return errorEvent;
  } else {
    const loadingEvent = new ReverseGeocodeEvent.Loading();
    return loadingEvent;
  }
}

export function mapLocationHttpErrorToReverseGeocodeErrorEvent(error: MSHttpEvent.Error): ReverseGeocodeEvent.Error {
  const errorEvent = new ReverseGeocodeEvent.Error();
  return errorEvent;
}
